import api from './api';

/**
 * Categorias e materiais são catálogo: mudam raramente e são pedidos por vários
 * componentes da mesma tela (busca, explorador e os dois painéis de filtro —
 * coluna e gaveta). Sem isto, abrir a home disparava o mesmo GET quatro vezes.
 *
 * A promessa é guardada, e não o resultado, para que chamadas simultâneas
 * compartilhem a requisição em voo em vez de abrirem uma cada.
 */
const cache = new Map();

function loadOnce(path) {
  if (!cache.has(path)) {
    cache.set(
      path,
      api
        .get(path)
        .then(response => response.data)
        // Falha não fica memorizada: a próxima tela tenta de novo.
        .catch(error => {
          cache.delete(path);
          throw error;
        })
    );
  }

  return cache.get(path);
}

function getProjectCategories() {
  return loadOnce('/project_categories');
}

function getMaterials() {
  return loadOnce('/materials');
}

export { getProjectCategories, getMaterials };
